import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesPendingApprovalListComponent } from './cases-pending-approval-list/cases-pending-approval-list.component';

const routes: Routes = [
  {
    path: 'cases-pending-approval',
    children: [
      { path: '', component: CasesPendingApprovalListComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CasesPendingApprovalRoutingModule { }
